module.exports = __webpack_public_path__ + "static/img/1.4d45168.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/1.png
// module id = xt/a
// module chunks = 0